import { batch } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { IAvailableSeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';
import { ISeasonTicketPaySum, seasonTicketPaySum } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/pay-sum';

import { getTicketDataLayerLabel, pushDataLayer } from '~/src/features/payments-abn/components/SeasonTicketPayment/helpers';
import {
    setBonusesAmount,
    setIsUseBonuses,
    setPaymentSumIsError,
    setPaymentSumIsLoading,
    setSeasonTicket,
} from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import validateBonusesAmount from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions/validateBonusesAmount';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import selectProviderId from '~/src/store/selectors/selectProviderId';

const updateSeasonTicket = (ticket: IAvailableSeasonTicket) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState) => {
        const state = getState();
        const { loyalty: { info: { bonuses } } } = state;
        const providerId = selectProviderId(state);

        const { id, countMonth, sumPrice, deltaPeriod, paySum } = ticket;

        let newPaySum = paySum;

        if (!paySum) {
            dispatch(setPaymentSumIsLoading(true));
            dispatch(setSeasonTicket(ticket));

            const response = await doRequest.apiSeasonTicket<ISeasonTicketPaySum>(seasonTicketPaySum(providerId, id));

            if (response.isSuccess) {
                newPaySum = response.payload.paySum;
                ticket.paySum = newPaySum;
                dispatch(setPaymentSumIsError(false));
            } else {
                dispatch(setPaymentSumIsError(true));
            }
        }

        pushDataLayer('subscription_type_choosed', getTicketDataLayerLabel({ countMonth, sumPrice, deltaPeriod }));

        const bonusesAmount = newPaySum ? Math.floor(newPaySum) : 0;

        batch(() => {
            dispatch(setSeasonTicket(ticket));
            dispatch(setPaymentSumIsLoading(false));
            dispatch(setBonusesAmount(Math.min(bonuses, bonusesAmount)));
            dispatch(setIsUseBonuses(false));
            dispatch(validateBonusesAmount());
        });
    };
};

export default updateSeasonTicket;
